import React, { useEffect, useState } from 'react'
import { getApiHeader } from 'utlis/commonfunctions';
import axios from 'axios'
import Payment from './Components/Payment'
import Summary from './Components/Summary'
import YourMobileNumber from './Components/YourMobileNumber'
import YourTelsimSim from './Components/YourTelsim'
import Plans from './Components/Plan/Plans'
import IdValidation from './Components/IdValidation'
import CreateAccount from './Components/CreateAccount'
import StaffDetails from './Components/StaffDetails'
import HomeScreen from './Components/HomeScreen';
import AccountCheck from './Components/AccountCheck';






const SERVER_URL = process.env.REACT_APP_API_URL;
function PostPaidActivation() {
 
 
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activationSuccessMsg, setActivationSuccessMsg] = useState("")
  const [activationSuccessData,setActivationSuccessData] = useState([])
  const [validationStatus,setValidationStatus]=useState(false)
  const [userEmail,setUserEmail]=useState("")

//    useEffect(() => {
//     const userType = sessionStorage.getItem('userType');
//     setStep(userType === "PAR" ? 1 : 0); 
// }, []);









  const [retailerDetails,setretailerDetails] = useState(null);
  const getRetailerData = (data) => {
    setretailerDetails(data);
  };


  const [commonSession,setCommonSession] = useState(null);
  const getSession = (data) => {
    setCommonSession(data);
  };


  const [userAccountData,setUserAccountData] = useState([]);
  const accountData = (data) => {
    setUserAccountData(data);
  };



  const [planDetails,setplanDetails] = useState([]);
  const planData = (data) => {
    setplanDetails(data);
  };



  const [selectedPlanData,setSelectedPlanData] = useState([]);
  const PlanSelection = (data) => {
    setSelectedPlanData(data);
  };


  const [dvsdetails,setDvsdetails] = useState([]);
  const dvsEntries = (data) => {
    setDvsdetails(data);
  };
  

  const clearDvs = () => {
    setDvsdetails([]);
  };
 


  const [newMobile,setNewMobile] = useState(null);
  const selectedMobile = (data) => {
    setNewMobile(data);
  };
  


  const nextStep = () =>{setStep((prevStep) => prevStep + 1)} 
  const prevStep = () => setStep((prevStep) => prevStep - 1);

  const  getStep=(input)=>{

    setStep(input)
    
  }



  




  return (
    <div>
      <div>


        {/* {step=== 0&& <HomeScreen nextStep={nextStep}/>} */}
        {step === 1 && <YourTelsimSim nextStep={nextStep} prevStep={prevStep} commonSession={commonSession}  handleSession={getSession} handlePlanDetails={planData} handleRetailer={getRetailerData} />}
        {step === 2 && <Plans nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} planDetails={planDetails}  handlePlanSelection={PlanSelection} retailerDetails={retailerDetails} />}
        {step === 3 && <YourMobileNumber nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} selectedPlanData={selectedPlanData} handleMobile={selectedMobile} newMobile={newMobile}  setStep={setStep}    />}
        {step === 4 && <AccountCheck nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} setStep={setStep}  getValidationStatus={setValidationStatus} getUserEmail={setUserEmail}   />}
        {step === 5 && <IdValidation nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} handleDvsEntry={dvsEntries} dvs_Details={dvsdetails} />}
        {step === 6 && <CreateAccount nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} retailerDetails={retailerDetails} userEmail={userEmail} />}
        {step === 7 && <StaffDetails nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} handleAccount={accountData} validationStatus={validationStatus} setStep={setStep} />}
        {step === 8 && <Payment nextStep={nextStep} prevStep={prevStep} userAccountData={userAccountData} selectedPlanData={selectedPlanData} setActivationSuccessMsg={setActivationSuccessMsg} setActivationSuccessData={setActivationSuccessData} planDetails={planDetails} commonSession={commonSession} dvsdetails={dvsdetails} setStep={getStep} />}
        {step === 9 && <Summary nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} userAccountData={userAccountData} activationSuccessMsg={activationSuccessMsg} selectedPlanData={selectedPlanData} activationSuccessData={activationSuccessData} planDetails={planDetails} clearDvsEntry={clearDvs} />}

        {loading && <p>Loading...</p>}
        {error && <p className="error">{error}</p>}

        
      </div>
    </div>
  );
}

export default PostPaidActivation;
